<template>
  <div class="text-start mb-5">
    <div class="container push-up-6">
      <section>
        <h1 class="title text-uppercase mb-5">frequently asked question</h1>
        <div class="list-box">
          <div class="list-title p-4">
            မိဘများ အမေးအများဆုံး မေးခွန်း (၇) ခု (FAQ)
          </div>
          <div class="lists" v-show="font_type == 1">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    aria-expanded="true" aria-controls="collapseOne">
                    1. What is the minimum age for a child to begin attending
                    school?
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    At Shwe Maw Kun Preschool, children from the age of three
                    are accepted through the Assessment/Placement Test according
                    to the number of students determined for each class and each
                    room from the lists provided in advance.

                    <br />
                    <br />
                    Remark: We would like to inform that at Shwe Maw Kun Private
                    School, children attending the Weekend and Summer
                    International Programs are given precedence based on their
                    names.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    2. For the purpose of the Admission / Placement Test: What
                    specific topics are covered?
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    For Pre-School Assessment, there are five areas of
                    evaluation involved: 

                    <br />
                    > Emotional Growth: Assessment of Moral Development
                    <br />
                    > Physical Development: Evaluation of Physical Advancement
                    <br />
                    > Cognitive Development: Assessment of Intellectual
                    Advancement
                    <br />
                    > Language Development: Evaluation of Linguistic Advancement
                    <br />
                    >Social Development: Check on Relationship Growth

                    <br />
                    <br />
                    The Primary & Secondary Assessment/Placement Test assesses
                    English, Maths, and Science subjects based on the curriculum
                    provided by Pearson Edexcel (UK) and the International
                    syllabus.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    3. What subjects are there at school?
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    At Shwe Maw Kun Private School, students enjoy a well-rounded education through the Myanmar National
                    Curriculum, along with a wide range of co-curricular subjects and activities. Depending on the grade
                    level, students study core subjects such as English, Mathematics, Science, Computing, Myanmar, and
                    Social Studies. In addition, students participate in co-curricular subjects and activities that help
                    develop their creativity, critical thinking, communication, leadership, teamwork, and overall
                    personal growth, ensuring a balanced and enriching learning experience.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    4. What subjects are covered on the Extended Learning Platform, and what are the benefits?
                  </button>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    Our Extended Learning Platform provides students with continuous access to high-quality learning
                    resources beyond the classroom. It supports subjects including English, Mathematics, Science,
                    Computing, and other curriculum-based lessons, helping students reinforce their understanding at
                    their own pace.
                    <br />
                    <p class="bold">Benefits of the Extended Learning Platform include:</p>
                    ● 24/7 access to learning materials
                    <br />
                    ● Interactive lessons and practice activities
                    <br />
                    ● Revision support for classroom learning
                    <br />
                    ● Opportunities for independent learning
                    <br />
                    ● Regular progress monitoring and academic improvement
                    <br />
                    ● Greater flexibility for students and parents
                    <br />
                    The platform helps students build confidence, strengthen their knowledge, and develop lifelong
                    learning habits.

                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFive">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    5. What about Olympiad competitions—can we participate in those too?
                  </button>
                </h2>
                <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    Shwe Maw Kun Private School encourages students to participate in International Olympiad
                    Competitions. These competitions provide students with valuable opportunities to challenge
                    themselves academically, showcase their talents, and gain international exposure.
                    <p class="bold">Participating in Olympiads helps students:</p>

                    ● Develop higher-order thinking and problem-solving skills
                    <br />
                    ● Build confidence through healthy academic competition
                    <br />
                    ● Gain international recognition and achievement
                    <br />
                    ● Prepare for future academic success
                    <br />
                    ● Prepare for future academic success
                    <br />
                    We are proud to support and guide our students throughout their Olympiad journey and encourage every
                    eligible student to participate.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSix">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    6. What is the maximum allowable student capacity for a
                    classroom?
                  </button>
                </h2>
                <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    In a single classroom, the maximum recommended number of
                    students is typically between 15 and 25, ensuring optimal
                    learning conditions. It allows for effective interaction
                    between teachers and students.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSeven">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    7. What is the starting date of the school?
                  </button>
                </h2>
                <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    The academic year of Pre-school consists of two semesters:
                    the June semester, which starts in June, and the December
                    semester, which starts in December. In the case of
                    elementary and middle schools, the Ministry of Education
                    determines the starting date for the June semester, and the
                    ministry sets the specific date for the commencement of
                    classes as the academic year begins in June.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="lists" v-show="font_type == 2">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    aria-expanded="true" aria-controls="collapseOne">
                    ၁။ ကလေးအသက် ဘယ်အရွယ်လောက်ကနေ ကျောင်းအပ်စလက်ခံပါသလဲ။
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    ရွှေမော်ကွန်းအဆင့်မြင့်မူကြိုကျောင်းမှာ အသက် (၃) နှစ်မှစပြီး
                    ကလေးများအား ကြိုတင်ပေးထားသော အမည်စာရင်းများမှ
                    အတန်းတစ်တန်းနှင့် တစ်ခန်းချင်းစီအတွက် သတ်မှတ်ထားသော
                    ကျောင်းသားဦးရေအတိုင်း Assessment/ Placement Test စစ်ပြီး
                    လက်ခံပါသည်။ <br /><br />
                    မှတ်ချက်။ ။ ရွှေမော်ကွန်းကိုယ်ပိုင်ကျောင်းတွင် Weekend နှင့်
                    Summer International Programme တွင် တက်ရောက်လေ့လာသင်ယူနေသော
                    ကလေးများအား ကြိုတင်ပေးထားသော အမည်စာရင်းများအတိုင်း
                    ဦးစားပေးလက်ခံပေးပါသည်။
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    ၂။ ကျောင်း၀င်ခွင့်အတွက် Assessment / Placement Test က
                    ဘယ်အချက်တွေကို အဓိကစစ်ဆေးတာပါလဲ။
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    Pre-School အတွက် Assessment ကတော့ ဖွံ့ဖြိုးမှုနယ်ပယ် (၅)
                    ရပ်ကို အဓိကစစ်ဆေးပါတယ်။
                    <br />
                    ဖွံ့ဖြိုးမှုနယ်ပယ် (၅) ရပ်ကတော့<br />
                    > စာရိတ္တပိုင်းဆိုင်ရာဖွံ့ဖြိုးမှု
                    (စိတ်လှုပ်ရှားမှုဆိုင်ရာဖွံ့ဖြိုးမှု)<br />
                    > ကာယပိုင်းဆိုင်ရာဖွံ့ဖြိုးမှု<br />
                    > ဉာဏ်ရည်ပိုင်းဆိုင်ရာဖွံ့ဖြိုးမှု<br />
                    > ဘာသာစကားပိုင်းဆိုင်ရာဖွံ့ဖြိုးမှု<br />
                    > ပေါင်းသင်းဆက်ဆံရေးပိုင်းဆိုင်ရာဖွံဖြိုးမှု
                    များပေါ်အခြေခံပြီးစစ်ဆေးပါတယ်။<br />
                    <br />
                    Primary & Secondary Assessment/ Placement Test ကတော့ Pearson
                    Edexcel (UK) နှင့် International သင်ရိုးတို့ရဲ့
                    အဓိကဘာသာရပ်များဖြစ်တဲ့ English, Maths & Science
                    ဘာသာရပ်များကို စစ်ဆေးပါသည်
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    ၃။ ကျောင်းတွင် မည်သည့်ဘာသာရပ်များကို သင်ကြားပေးပါသလဲ?
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းတွင် ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့်
                    မြန်မာနိုင်ငံအမျိုးသားသင်ရိုးညွှန်းတမ်း (Myanmar National Curriculum) ကို အခြေခံ၍ သင်ယူကြပြီး၊
                    ဘက်စုံဖွံ့ဖြိုးတိုးတက်စေရန်အတွက် ထပ်ဆောင်း ဘာသာရပ်များ (Co-curricular Subjects and Activities)
                    ကိုလည်း စီစဉ်ပေးထားပါသည်။ အတန်းအဆင့်အလိုက် မြန်မာစာ၊ အင်္ဂလိပ်စာ၊ သင်္ချာ၊ သိပ္ပံ၊ လူမှုရေးနှင့်
                    ကွန်ပျူတာ ဘာသာရပ်များကို အဓိကထားသင်ကြားပေးပါသည်။
                    အဆိုပါ သင်ကြားသင်ယူမှု အခွင့်အလမ်းများမှတစ်ဆင့် တီထွင်ဖန်တီးနိုင်စွမ်း၊
                    ဝေဖန်ပိုင်းခြားတွေးခေါ်နိုင်စွမ်း၊ ဆက်သွယ်ပြောဆိုနိုင်စွမ်း၊ ခေါင်းဆောင်မှုနှင့်
                    အဖွဲ့လိုက်ပူးပေါင်းဆောင်ရွက်နိုင်စွမ်းတို့ကို ဖွံ့ဖြိုးတိုးတက်စေရန် အထောက်အကူပြုပါသည်။
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    ၄။ Extended Learning Platform တွင် မည်သည့်ဘာသာရပ်များကို လေ့လာနိုင်ပြီး မည်သည့်အကျိုးကျေးဇူးများ
                    ရရှိနိုင်ပါသလဲ?
                  </button>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    Extended Learning Platform မှတစ်ဆင့် ကျောင်းသား၊ ကျောင်းသူများသည် စာသင်ခန်းအတွင်း သင်ယူရရှိထားသည့်
                    အကြောင်းအရာများကို စာသင်ချိန်ပြင်ပတွင်လည်း ဆက်လက်လေ့လာနိုင်ရန် စီစဉ်ပေးထားသော
                    သင်ယူမှုပလက်ဖောင်းတစ်ခု ဖြစ်ပါသည်။ ဤပလက်ဖောင်းတွင် အင်္ဂလိပ်စာ၊ သင်္ချာ၊ သိပ္ပံ၊ ကွန်ပျူတာစသည့်
                    သင်ခန်းစာများ ပါဝင်ပြီး၊ ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် မိမိတို့အဆင်ပြေသည့် အချိန်တွင်
                    လေ့လာသင်ယူနိုင်ရန်ရည်ရွယ်ပါသည်။

                    <p class="bold">Extended Learning Platform ၏ အကျိုးကျေးဇူးများ</p>
                    ● သင်ခန်းစာများကို အချိန်မရွေး လေ့လာနိုင်ခြင်း
                    <br />
                    ● စိတ်ပါဝင်စားမှုရှိစေရန်လှုံ့ဆော်ပေးသော သင်ယူမှု ပုံစံဖြင့်လေ့လာနိုင်ခြင်း
                    <br />
                    ● သင်ယူထားသောသင်ခန်းစာများကို ပြန်လည်လေ့လာနိုင်ရန် အထောက်အကူပြုခြင်း
                    <br />
                    ● မိမိကိုယ်တိုင် လေ့လာသင်ယူနိုင်သည့် အလေ့အကျငိ့ကောင်းများ တိုးတက်လာခြင်း
                    <br />
                    ● သင်ယူမှုဆိုင်ရာတိုးတက်မှု မှတ်တမ်းများကို စဉ်ဆက်မပြတ်စောင့်ကြည့်ခြင်း
                    တို့ကိုအထောက်အကူပြုပါသည်။
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFive">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    ၅။ နိုင်ငံတကာ အိုလံပစ် ပြိုင်ပွဲများတွင်လည်း ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့်
                    ပါဝင်ယှဉ်ပြိုင်နိုင်ပါသလား?
                  </button>
                </h2>
                <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းတွင် ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် နိုင်ငံတကာအိုလံပစ်
                    ပြိုင်ပွဲများ (International Olympiad Competitions) တွင် ပါဝင်ယှဉ်ပြိုင်နိုင်ရန်
                    အားပေးကူညီပေးလျက်ရှိပါသည်။ အဆိုပါပြိုင်ပွဲများသည် ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် မိမိတို့၏
                    ပညာရပ်ဆိုင်ရာစွမ်းရည်များကို စမ်းသပ်မြှင့်တင်နိုင်ရန်၊ မိမိတို့၏ ထူးချွန်မှုများကို
                    ဖော်ထုတ်ပြသနိုင်ရန်နှင့် နိုင်ငံတကာအဆင့်တွင် အတွေ့အကြုံများ ရရှိနိုင်ရန် အဖိုးတန်အခွင့်အလမ်းများကို
                    ပေးစွမ်းပါသည်။

                    <p class="bold">အိုလံပစ် ပြိုင်ပွဲများတွင် ပါဝင်ယှဉ်ပြိုင်ခြင်းဖြင့်—</p>
                    ● တွေးခေါ်မှုနှင့် ပြဿနာဖြေရှင်းနိုင်စွမ်းများ တိုးတက်လာစေခြင်း
                    <br />
                    ● ပညာရပ်ဆိုင်ရာ ယှဉ်ပြိုင်မှုများမှတစ်ဆင့် မိမိကိုယ်ကို ယုံကြည်မှု တိုးတက်လာစေခြင်း
                    <br />
                    ● နိုင်ငံတကာအဆင့် အသိအမှတ်ပြုမှုနှင့် ထူးချွန်အောင်မြင်မှုများ ရရှိနိုင်ခြင်း
                    <br />
                    ● အနာဂတ်ပညာရေးအောင်မြင်မှုများအတွက် ကြိုတင်ပြင်ဆင်ပေးနိုင်ခြင်း
                    တို့ကို အထောက်အကူပြုပါသည်။
                    <br />
                    သတ်မှတ်ချက်များနှင့် ကိုက်ညီသော ကျောင်းသား၊ ကျောင်းသူတိုင်း ပြိုင်ပွဲများတွင် ပါဝင်ယှဉ်ပြိုင်ရန်လည်း
                    အားပေးတိုက်တွန်းလျက်ရှိပြီး အိုလံပစ်ပြိုင်ပွဲတွင် ပါဝင်ယှဉ်ပြိုင်သည့် လမ်းကြောင်းတစ်လျှောက်
                    လိုအပ်သည့် လမ်းညွှန်မှုနှင့် ပံ့ပိုးကူညီမှုများကို ပေးနိုင်ရန် အလေးထား ဆောင်ရွက်လျက်ရှိပါသည်။
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSix">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    ၆။ စာသင်ခန်းတစ်ခန်းမှာ ကျောင်းသား/သူဦးရေ အများဆုံး
                    ဘယ်နှစ်ယောက်ထားပါသလဲ။
                  </button>
                </h2>
                <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    စာသင်ခန်းတစ်ခန်းမှာဆိုရင် အခန်းအကျယ်အ၀န်းပေါ်မူတည်ပြီး
                    ကျောင်းသားဦးရေ (၁၅ - ၂၅) သာ အများဆုံး လက်ခံသင်ကြားပေးပါတယ်။
                    ဆရာ/ဆရာမ နဲ့ ကျောင်းသား/သူ အချိုးကျထားရှိပါသည်။
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSeven">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    ၇။ ကျောင်းက ဘယ်နှစ်လပိုင်းမှာစဖွင့်ပါသလဲ။
                  </button>
                </h2>
                <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    မူကြိုဆိုရင် တစ်နှစ်မှာ Semester နှစ်ခုရှိပါတယ်။ June
                    Semester နဲ့ December Semester ဆိုပြီး နှစ်စဉ် June
                    မှာတစ်ကြိမ် ၊ December မှာတစ်ကြိမ် ဖွင့်လှစ်ပါသည်။
                    မူလတန်းကျောင်းနဲ့ အလယ်တန်းကျောင်းကတော့
                    ပညာရေးဝန်ကြီးဌာနကသတ်မှတ်ထားတဲ့အတိုင်း နှစ်စဉ် June လမှာ
                    ဖွင့်လှစ်ပါသည်။
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    font_type() {
      return this.$store.state.font_type;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  letter-spacing: 5px;
  font-weight: var(--cus-fw-semibold);
  color: var(--cus-secondary);
}

.sub-title {
  color: var(--cus-primary);
}

.list-title {
  text-transform: uppercase;
  font-weight: var(--cus-fw-semibold);
  font-size: var(--cus-fs-xx-large);
  color: var(--cus-white);
  background-color: var(--cus-primary);
}

.list-box {
  // border: 1px solid var(--cus-dark)
}

.accordion-item:first-of-type,
.accordion-item:first-of-type .accordion-button,
.accordion-item:last-of-type,
.accordion-item:last-of-type .accordion-button {
  border-radius: 0 !important;
}

.accordion-body {
  white-space: pre-wrap;
  line-height: 30px;
}

.lists {
  div {
    font-size: var(--fs-xx-large);
  }
}

.push-up-6 {
  margin-top: 6rem;
}
</style>
